import { render, staticRenderFns } from "./StartPrize.vue?vue&type=template&id=50dc9261&scoped=true&"
import script from "./StartPrize.vue?vue&type=script&lang=js&"
export * from "./StartPrize.vue?vue&type=script&lang=js&"
import style0 from "./StartPrize.vue?vue&type=style&index=0&id=50dc9261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc9261",
  null
  
)

export default component.exports